import { Button } from '@tumelo/designsystem'
import React from 'react'
import { resolveAllNotifications } from '../../application/features/notifications/asyncActions'
import { useAppDispatch } from '../../application/store'

export const MarkAllAsReadButton: React.FC = () => {
  const dispatch = useAppDispatch()

  const markAllAsRead = () => {
    dispatch(resolveAllNotifications())
  }

  return (
    <Button onClick={markAllAsRead} size="small" variant="tertiary">
      Mark all as read
    </Button>
  )
}
